export const memberToMentionConverter = ({ id, name, displayName, profilePicture, }) => {
    var _a, _b;
    return ({
        id,
        title: displayName || name,
        icon: ((_a = profilePicture) === null || _a === void 0 ? void 0 : _a.url) || ((_b = profilePicture) === null || _b === void 0 ? void 0 : _b.text),
    });
};
//# sourceMappingURL=composer.js.map